export default __webpack_public_path__ + "static/media/search_for_items.b2206ff7.png";